import { SYSTEM_VARIABLE_CATALOG, filterVariablesBySearch, isSystemVariable, normalizeVariableLabel } from '../TemplateVariables.utils';
export const CATEGORY_ORDER = [
    'Client',
    'My Business',
    'Agreement'
];
function filterSystemVariables(search) {
    const trimmed = search.trim();
    if (!trimmed) {
        return [
            ...SYSTEM_VARIABLE_CATALOG
        ];
    }
    const normalizedSearch = normalizeVariableLabel(trimmed);
    return SYSTEM_VARIABLE_CATALOG.filter((entry)=>normalizeVariableLabel(entry.label).includes(normalizedSearch));
}
function groupSystemVariablesByCategory(filteredSystemVars) {
    const grouped = new Map();
    for (const category of CATEGORY_ORDER){
        const entries = filteredSystemVars.filter((v)=>v.category === category);
        if (entries.length > 0) {
            grouped.set(category, entries);
        }
    }
    return grouped;
}
export function buildSelectableItems(searchText, customVariables, excludeLabels) {
    const filteredSystem = filterSystemVariables(searchText).filter((v)=>!excludeLabels.has(normalizeVariableLabel(v.label)));
    const grouped = groupSystemVariablesByCategory(filteredSystem);
    const filteredCustom = filterVariablesBySearch(customVariables.map((label)=>({
            label
        })), searchText).map((v)=>v.label);
    const items = [];
    for (const [category, entries] of grouped){
        for (const entry of entries){
            items.push({
                type: 'variable',
                label: entry.label,
                category,
                subcategory: 'subcategory' in entry ? entry.subcategory : undefined
            });
        }
    }
    for (const label of filteredCustom){
        items.push({
            type: 'variable',
            label,
            category: 'Custom'
        });
    }
    return items;
}
export function canCreateVariable(searchText, customVariables) {
    const trimmed = searchText.trim();
    if (trimmed.length === 0) return false;
    return !isSystemVariable(trimmed) && !customVariables.some((v)=>normalizeVariableLabel(v) === normalizeVariableLabel(trimmed));
}
export function getCategoryForItem(items, index) {
    var _item_subcategory, _prevItem_subcategory;
    const item = items[index];
    const currentHeader = (_item_subcategory = item.subcategory) !== null && _item_subcategory !== void 0 ? _item_subcategory : item.category;
    if (index === 0) {
        return currentHeader;
    }
    const prevItem = items[index - 1];
    const prevHeader = (_prevItem_subcategory = prevItem.subcategory) !== null && _prevItem_subcategory !== void 0 ? _prevItem_subcategory : prevItem.category;
    if (item.category !== prevItem.category || currentHeader !== prevHeader) {
        return currentHeader;
    }
    return null;
}
